<template>
    <div id="main">
        <div class="page">
            <alert-container :messages="msgs" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('bandeira') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a>{{ $t('promotor') }}</a>
                                </li>
                                <li>
                                    <a>{{ $t('cadastros') }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'pro-bandeira-list' })">{{
                                        $t('bandeiras')
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        !bandeira.idprobandeira
                                            ? $t('nova-bandeira')
                                            : bandeira.descricao
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({
                                    name: 'pro-bandeira-list',
                                })
                            "
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                ((!isUpdate && permissao.create) ||
                                    (isUpdate && permissao.update)) &&
                                !bandeiraIntegracao
                            "
                            class="save-btn"
                            type="button"
                            @click="salvar()"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit page-container">
                    <div class="columns is-flex-wrap">
                        <div class="column is-4">
                            <v-input
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="bandeira.idprobandeiraerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!bandeira.idprobandeiraerp"
                            />
                        </div>
                        <div class="column is-8">
                            <v-input
                                :id="generateId(2)"
                                v-model="bandeira.descricao"
                                :placeholder="'descricao-da-bandeira-placeholder'"
                                :maxlength="50"
                                :title="'descricao-da-bandeira'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!bandeira.descricao"
                                ref="descricaoInput"
                                :required="true"
                            />
                        </div>
                        <div class="column is-6">
                            <vss-select
                                :id="generateId(3)"
                                ref="redeInput"
                                :title="'rede-da-bandeira'"
                                :searchable="true"
                                @search="loadRede($event)"
                                :options="redes"
                                v-model="rede"
                                @onBlurFunction="sendIsChanged()"
                                :placeholder="'rede-da-bandeira-placeholder'"
                                :loading="isLoadingRede"
                                :invalid="!rede"
                                :required="true"
                            />
                        </div>
                        <div class="column is-6">
                            <vss-select
                                :id="generateId(4)"
                                title="situacao"
                                ref="situacaoSelect"
                                :options="situacoes"
                                v-model="situacao"
                                mlLabels
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BandeiraService from '@/services/promotor/BandeiraService';
import RedeService from '@/services/promotor/RedeService';
import BandeiraValidation from '@/services/validations/BandeiraValidation';
import Message from '@/models/Message';

export default {
    data() {
        return {
            bandeiraIntegracao: this.$store.state.user.tabelasERPWebServer.includes('PRO_BANDEIRA'),
            isSaving: false,
            bandeira: {
                idprobandeiraerp: null,
                prorede: { idprorede: null },
                situacao: 1,
            },
            redes: [],
            rede: null,
            editable: false,
            title: '',
            msgs: [],
            validation: null,
            canSelectRede: false,
            situacao: { label: 'ativo', id: 1 },
            situacoes: [
                { label: 'ativo', id: 1 },
                { label: 'inativo', id: 0 },
            ],
            isUpdate: false,
            isLoadingRede: false,
            isChanged: false,
            isLoadingEdit: false,
        };
    },
    created() {
        if (this.bandeira != null && this.bandeira != {}) {
            this.editable = true;
        }

        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'bandeiras');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'bandeira' },
            });
        } else {
            this.bandeiraservice = new BandeiraService(this.$http, this.$router);
            this.redeservice = new RedeService(this.$http, this.$router);
            this.validation = new BandeiraValidation(this.msgs);

            this.isUpdate = !!this.$route.params.id;
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: 'acesso-nao-permitido',
                    params: { tela: 'bandeira' },
                });
            }

            this.loadRede('');
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        sendIsChanged() {
            if (!this.isLoadingEdit && !this.isLoadingRede && !this.isSaving) {
                this.isChanged = true;
            }
        },
        getRede() {
            return this.bandeira.prorede
                ? this.redes.filter((v) => v.id == this.bandeira.prorede.idprorede)[0]
                : this.redes[0];
        },
        getSituacao() {
            return this.situacoes.find((s) => s.id == this.bandeira.situacao);
        },
        carregarDados(id) {
            this.isLoadingEdit = true;
            this.bandeiraservice
                .find(id)
                .then((body) => {
                    if (body.content) {
                        this.bandeira = body.content;
                        this.rede = this.getRede();
                        this.situacao = this.getSituacao();
                        this.title = this.bandeira.descricao;
                    } else {
                        this.$router.push({ name: 'pro-bandeira-new' });
                    }
                })
                .finally((_) => {
                    this.isChanged = false;
                    this.isLoadingEdit = false;
                });
        },
        loadRede(search) {
            this.isLoadingRede = true;
            this.redeservice
                .findAllCombo(search ? search : '')
                .then(this.mapItems)
                .then((allredes) => {
                    this.redes = allredes;
                    this.redes.sort();
                }, 350)
                .catch((e) => {})
                .finally(() => {
                    this.isChanged = false;
                    this.isLoadingRede = false;
                    if (this.$route.params.id) {
                        this.editable = false;
                        this.carregarDados(this.$route.params.id);
                    }
                });
        },
        zeraLatLong() {
            this.isLoadingEdit = true;

            this.bandeira.latitude = 0;
            this.bandeira.longitude = 0;

            this.isLoadingEdit = false;
        },
        salvar() {
            this.isSaving = true;
            this.bandeira.prorede.idprorede = this.rede ? this.rede.id : null;
            this.bandeira.situacao = this.situacao.id;
            this.bandeira = this.mapTosave(this.bandeira);
            if (this.validation.validate(this.bandeira, this.$refs)) {
                this.bandeiraservice
                    .save(this.bandeira)
                    .then((body) => {
                        if (body.content) {
                            let msg = 'msg-bandeira-salva';
                            if (this.isUpdate) {
                                msg = 'msg-bandeira-edita';
                            }
                            this.bandeira = body.content;
                            this.msgs.push(new Message('success', msg, true));
                            if (!this.isUpdate) {
                                this.redirectToList();
                            }
                        } else {
                            if (this.$te(body.message)) {
                                if (body.message == 'msg-codigo-duplicado-n') {
                                    this.msgs.push(
                                        new Message(
                                            'alert',
                                            this.$t(body.message, { n: this.bandeira.idprobandeiraerp }),
                                            true,
                                            false
                                        )
                                    );
                                } else {
                                    this.msgs.push(new Message('alert', body.message, true));
                                }
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                    })
                    .finally(() => {
                        this.isChanged = false;
                        this.isSaving = false;
                    });
            } else {
                this.isChanged = false;
                this.isSaving = false;
            }
        },
        redirectToList() {
            this.isChanged = false;
            this.$router.push({
                name: 'pro-bandeira-list',
            });
        },
        mapItems(body) {
            return body.content.map((r) => {
                return {
                    id: r.id,
                    label: r.descricao,
                };
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    .page {
        position: relative;
    }
}
</style>
